import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PermisosService } from '../../services/permisos.service';
import { AlertService } from '../alert/alert.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  username = new FormControl('', Validators.required);
  password = new FormControl('', Validators.required);
  repeatPassword = new FormControl('');
  loading: boolean = false;

  showChangePasswordForm: boolean = false;
  idAsociadoToChangePassword: number = -1;

  /** Se ha intentado enviar el formulario: a partir de ahí se muestran los errores de cada campo. */
  intentado = false;
  /** Mensaje persistente del último intento fallido (además del aviso temporal). */
  errorGeneral = '';
  mostrarPassword = false;

  constructor(
    private authService: AuthService,
    private route: Router,
    private alertService: AlertService,
    private permisos: PermisosService
  ) {}

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.route.navigateByUrl('home');
    }
  }

  get faltaUsuario(): boolean {
    return this.intentado && !this.username.value;
  }

  get faltaPassword(): boolean {
    return this.intentado && !this.password.value;
  }

  get faltaRepetir(): boolean {
    return this.intentado && !this.repeatPassword.value;
  }

  get noCoinciden(): boolean {
    return this.intentado && !!this.repeatPassword.value && this.password.value !== this.repeatPassword.value;
  }

  async login() {
    this.intentado = true;
    this.errorGeneral = '';
    if (this.loading || !this.username.valid || !this.password.valid) {
      return;
    }
    this.loading = true;
    try {
      const codeLogin: any = await this.authService.login(this.username.value!, this.password.value!);
      if (codeLogin.code === 200) {
        // Los permisos efectivos los calcula el servidor: se cargan antes de mostrar la pantalla de inicio.
        this.permisos.cargarContexto(true).subscribe(() => {
          this.loading = false;
          this.alertService.success('Bienvenido!', 5000);
          this.route.navigateByUrl('home');
        });
        return;
      } else if (codeLogin.code === 429 || codeLogin.code === 503) {
        this.errorGeneral = codeLogin.message || 'Acceso temporalmente no disponible. Espera unos minutos o contacta con administración.';
        this.alertService.danger(this.errorGeneral, 8000);
      } else if (codeLogin.code === 403) {
        this.errorGeneral = codeLogin.message || 'La cuenta no está activa.';
        this.alertService.danger(this.errorGeneral, 6000);
      } else if (codeLogin.code === 409) {
        // Correo compartido por varias personas: el servidor pide acceder con el documento personal.
        this.errorGeneral = codeLogin.message || 'Este correo lo comparten varias personas. Accede con tu DNI/NIE u otro documento personal.';
        this.alertService.danger(this.errorGeneral, 8000);
      } else if(codeLogin.code === 400) {
        this.errorGeneral = 'Datos incorrectos de inicio de sesión.';
        this.alertService.danger(this.errorGeneral, 5000)
      } else if (codeLogin.code === 201) {
        this.idAsociadoToChangePassword = codeLogin.id;
        this.showChangePasswordForm = true;
        this.intentado = false;
        this.password.reset();
      }
    } catch {
      this.errorGeneral = 'No se ha podido iniciar sesión. Inténtalo de nuevo.';
      this.alertService.danger(this.errorGeneral, 5000);
    }
    this.loading = false;
  }

  changePassword() {
    this.intentado = true;
    if (!this.password.value || !this.repeatPassword.value) {
      return;
    }
    if (this.password.value !== this.repeatPassword.value) {
      this.alertService.danger('Las contraseñas no coinciden.', 5000);
      return;
    }
    this.loading = true;
    this.authService.updatePassword(this.idAsociadoToChangePassword, this.password.value!)
      .then((res: any) => {
        this.loading = false;
        this.alertService.success('Contraseña actualizada correctamente.', 5000);
        this.showChangePasswordForm = false;
        this.intentado = false;
      })
      .catch((error: any) => {
        this.loading = false;
        this.alertService.danger('Error al actualizar la contraseña.', 5000);
      });
  }

}
